import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup }            from '@angular/forms';
import { UntilDestroy, untilDestroyed }                   from '@ngneat/until-destroy';
import { Store }                                          from '@ngrx/store';
import { ESTATE_FORMULE }                                 from '@shared/enums/ESTATE_FORMULE';
import { FormuleEnum }                                    from '@shared/enums/formule.enum';
import { BehaviorSubject, Observable, Subject }           from 'rxjs';
import { map }                                            from 'rxjs/operators';
import { DataTarificationPhaseB }                         from 'src/app/components/main/oav-phase-b/preconisation/dataTarificationPhaseB';
import { ErrorOnFormgroup }                               from 'src/app/shared/errors/errorOnFormgroup';
import { ITarificationState }                             from 'src/app/shared/ngrx/store/state/tarification/tarification.state';
import { BorderPreconisation }                            from '../borderPreconisation';
import { CellsHeader }                                    from '../cells-header';
import { PriceFormuleParameters }                         from '../priceFormuleParameters';

@UntilDestroy ()
@Component ({ template: '' })
export abstract class AbstractPrecoOavComponent implements OnInit {
  @Input ()
  ar: CellsHeader[];

  @Input ()
  changePrice$: Observable<PriceFormuleParameters[]>;

  @Input ()
  changeBorder$: BehaviorSubject<BorderPreconisation[]>;

  @Input ()
  public checkProject$: Subject<DataTarificationPhaseB>;

  @Output ()
  onCheck: EventEmitter<DataTarificationPhaseB>;

  @Output ()
  onError: EventEmitter<ErrorOnFormgroup>;

  @Input ()
  formuleSelected: FormuleEnum;

  public border: any;
  public formGroup: FormGroup;

  protected constructor (protected _fb: FormBuilder, protected _store: Store<ITarificationState>) {
    this.formGroup = _fb.group ({});
    this.onCheck   = new EventEmitter<DataTarificationPhaseB> ();
    this.onError   = new EventEmitter<ErrorOnFormgroup> ();
  }

  ngOnInit (): void {
    const control = new FormControl ('');
    this.formGroup.addControl (this.formuleSelected, control, { emitEvent: false });
    this.changeBorder$.pipe (
      untilDestroyed (this),
      map (m => {
        const b         = this.getBorder (m, this.formuleSelected);
        this.border     = b.border;
        const emitEvent = [FormuleEnum.SUR_MESURE].includes (this.formuleSelected);
        this.formGroup.get (this.formuleSelected).setValue (b.selected, { emitEvent });

      }),
    ).subscribe ();
  }

  private getBorder (borders: BorderPreconisation[], formuleEnum: FormuleEnum): BorderPreconisation {
    const b = borders.find (f => f.formuleEnum === formuleEnum);
    if (!b) {
      throw new Error (`no border found in list for formule [${formuleEnum}]`);
    }
    return b;
  }

  trackById (index, item: CellsHeader) {
    return item.id;
  }

  check (check: boolean, formule: any) {
    const c = new DataTarificationPhaseB ();
    c.check = check ? ESTATE_FORMULE.CHECKED : ESTATE_FORMULE.NOT_SHOW;
    c.id    = formule;
    this.onCheck.emit (c);
  }

}
